import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "./scss/index.scss";
import classNames from "classnames";
import { stringify } from "query-string";
import * as React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import ReactSVG from "react-svg";
import { Icon, Loader } from "@components/atoms";
import { perPage } from "@temp/constants";
import { Button, // Loader,
OfflinePlaceholder, Overlay, OverlayType } from "../..";
import { searchUrl } from "../../../app/routes";
import { maybe } from "../../../core/utils";
import { withRouter } from "../../../core/withRouter";
import { DebouncedTextField } from "../../Debounce";
import { Error } from "../../Error";
import NetworkStatus from "../../NetworkStatus";
import NothingFound from "./NothingFound";
import ProductItem from "./ProductItem";
import { TypedSearchResults } from "./queries";
import searchImg from "../../../images/searchIcon.svg";
import closeImg from "../../../images/close-thin.svg";
import goBackImg from "../../../images/goback.svg"; // import searchEmptyImg from "../../../images/searchInputEmpty.svg";

import searchEmptyImg from "../../../images/search-v5.svg";
var PRODUCTS_PER_PAGE = +perPage;

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Search)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      search: "",
      searchInput: "",
      resetValue: false
    }, _this.submitBtnRef = React.createRef(), _this.iconLeftRef = React.createRef(), _this.inputRef = React.createRef(), _this.hasResults = function (data) {
      return maybe(function () {
        return !!data.productsSearchLightLoad.edges.length;
      });
    }, _this.handleSubmit = function (evt) {
      evt.preventDefault(); // if (this.hasSearchPhrase && this.submitBtnRef.current) {
      //   this.props.overlay.hide();
      //   this.props.history.push(`${searchUrl}?${this.searchQs}`);
      // }

      _this.handleOnClickIconRight();
    }, _this.handleInputBlur = function () {
      if (!_this.hasSearchPhrase) {
        _this.props.overlay.hide();
      }
    }, _this.handleOnClickIconLeft = function () {
      _this.inputRef.current.focus();

      _this.iconLeftRef.current.classList.add("input__icon-left--disabled");

      _this.iconLeftRef.current.classList.remove("input__icon-left--enabled");

      _this.setState({
        search: "",
        searchInput: "",
        resetValue: true
      });
    }, _this.handleOnClickIconRight = function () {
      if (_this.state.search !== _this.state.searchInput) {
        _this.setState(function (actualState) {
          return _objectSpread(_objectSpread({}, actualState), {}, {
            searchInput: actualState.search
          });
        });
      }
    }, _this.handleOnChange = function (evt) {
      if (evt.target.value.length > 0) {
        _this.iconLeftRef.current.classList.remove("input__icon-left--disabled");

        _this.iconLeftRef.current.classList.add("input__icon-left--enabled");
      }

      if (evt.target.value === "") {
        _this.iconLeftRef.current.classList.add("input__icon-left--disabled");

        _this.iconLeftRef.current.classList.remove("input__icon-left--enabled");

        _this.setState({
          searchInput: ""
        });
      }

      _this.setState({
        search: evt.target.value
      });
    }, _this.handleOnkeyUp = function (evt) {
      if (evt.target.value.length > 0) {
        _this.iconLeftRef.current.classList.remove("input__icon-left--disabled");

        _this.iconLeftRef.current.classList.add("input__icon-left--enabled");
      } else {
        _this.iconLeftRef.current.classList.add("input__icon-left--disabled");

        _this.iconLeftRef.current.classList.remove("input__icon-left--enabled");
      }
    }, _temp));
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.iconLeftRef.current.classList.add("input__icon-left--disabled");
      this.iconLeftRef.current.classList.remove("input__icon-left--enabled");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (!!prevState.search.length && this.props.overlay.type !== OverlayType.search) {
        this.setState({
          search: "",
          searchInput: "",
          resetValue: false
        });
      }

      if (this.state.resetValue) {
        this.setState({
          search: "",
          searchInput: "",
          resetValue: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Overlay, {
        testingContext: "searchOverlay",
        context: this.props.overlay,
        className: "overlay"
      }, React.createElement("form", {
        className: classNames("search", {
          "search--has-results": this.hasSearchPhrase
        }),
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onSubmit: this.handleSubmit
      }, React.createElement("div", {
        className: "search__input"
      }, React.createElement("div", {
        className: "search__input__up"
      }, React.createElement("div", {
        className: "search__input__up__goback"
      }, React.createElement(ReactSVG, {
        path: goBackImg,
        onClick: this.props.overlay.hide
      })), React.createElement("p", {
        className: "search__input__up__title"
      }, "\xBFQu\xE9 buscas?")), React.createElement("div", {
        className: "search__input__down"
      }, React.createElement(DebouncedTextField, {
        onKeyDown: function onKeyDown(evt) {
          return _this2.handleOnkeyUp(evt);
        },
        inputRef: this.inputRef,
        iconLeftRef: this.iconLeftRef,
        resetValue: this.state.resetValue,
        onChange: function onChange(evt) {
          return _this2.handleOnChange(evt);
        },
        value: this.state.search,
        iconRight: React.createElement(ReactSVG, {
          path: searchImg
        }),
        iconLeft: React.createElement(ReactSVG, {
          path: closeImg
        }),
        placeholder: "Buscar...",
        autoFocus: true,
        onClickIconRight: function onClickIconRight() {
          return _this2.handleOnClickIconRight();
        },
        onClickIconLeft: function onClickIconLeft() {
          return _this2.handleOnClickIconLeft();
        }
      })))), React.createElement("div", {
        className: classNames({
          search__products: true,
          "search__products--expanded": this.hasSearchPhrase
        })
      }, React.createElement(NetworkStatus, null, function (isOnline) {
        if (_this2.hasSearchPhrase && _this2.state.searchInput.length > 0) {
          return React.createElement(TypedSearchResults, {
            renderOnError: true,
            displayError: false,
            errorPolicy: "all",
            variables: {
              query: _this2.state.searchInput,
              perPage: PRODUCTS_PER_PAGE
            }
          }, function (_ref) {
            var data = _ref.data,
                error = _ref.error,
                loadMore = _ref.loadMore,
                loading = _ref.loading;

            if (_this2.hasResults(data)) {
              return React.createElement(React.Fragment, null, React.createElement("ul", null, data.productsSearchLightLoad.edges.map(function (productVariant) {
                var _productVariant$node, _productVariant$node2, _productVariant$node3, _productVariant$node4, _productVariant$node5, _productVariant$node6, _productVariant$node7, _productVariant$node8;

                var product = {
                  category: {
                    id: productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node = productVariant.node) === null || _productVariant$node === void 0 ? void 0 : _productVariant$node.categoryIdLightLoad,
                    name: productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node2 = productVariant.node) === null || _productVariant$node2 === void 0 ? void 0 : _productVariant$node2.categoryNameLightLoad,
                    __typename: "Category"
                  },
                  subCategory: {
                    id: productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node3 = productVariant.node) === null || _productVariant$node3 === void 0 ? void 0 : _productVariant$node3.subCategoryIdLightLoad,
                    name: productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node4 = productVariant.node) === null || _productVariant$node4 === void 0 ? void 0 : _productVariant$node4.subCategoryNameLightLoad,
                    __typename: "Category"
                  },
                  id: productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node5 = productVariant.node) === null || _productVariant$node5 === void 0 ? void 0 : _productVariant$node5.id,
                  name: (productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node6 = productVariant.node) === null || _productVariant$node6 === void 0 ? void 0 : _productVariant$node6.name) || (productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node7 = productVariant.node) === null || _productVariant$node7 === void 0 ? void 0 : _productVariant$node7.productNameLightLoad),
                  thumbnail: productVariant === null || productVariant === void 0 ? void 0 : (_productVariant$node8 = productVariant.node) === null || _productVariant$node8 === void 0 ? void 0 : _productVariant$node8.thumbnailLightLoad,
                  __typename: "Product"
                };
                return React.createElement(ProductItem, {
                  product: product,
                  key: product.id
                });
              })), data.productsSearchLightLoad.pageInfo.hasNextPage && React.createElement("div", {
                className: "search__products__footer"
              }, loading ? React.createElement(Loader, null) : React.createElement("div", {
                className: "search__products__footer__loadMore"
              }, React.createElement(Button, {
                onClick: function onClick() {
                  var _data$productsSearchL;

                  loadMore(function (prev, next) {
                    return {
                      productsSearchLightLoad: _objectSpread(_objectSpread({}, prev.productsSearchLightLoad), {}, {
                        edges: [].concat(_toConsumableArray(prev.productsSearchLightLoad.edges), _toConsumableArray(next.productsSearchLightLoad.edges)),
                        pageInfo: next.productsSearchLightLoad.pageInfo
                      })
                    };
                  }, {
                    after: data === null || data === void 0 ? void 0 : (_data$productsSearchL = data.productsSearchLightLoad.pageInfo) === null || _data$productsSearchL === void 0 ? void 0 : _data$productsSearchL.endCursor,
                    perPage: PRODUCTS_PER_PAGE,
                    query: _this2.state.search
                  });
                },
                testingContext: "searchProductsButton",
                btnRef: _this2.submitBtnRef,
                type: "submit"
              }, React.createElement(Icon, {
                size: 24,
                name: "plus",
                color: "#ED1C24"
              }), React.createElement("span", null, "Ver m\xE1s")))));
            }

            if (error) {
              return isOnline ? React.createElement(Error, {
                error: error.message
              }) : React.createElement(OfflinePlaceholder, null);
            }

            return React.createElement(NothingFound, {
              search: _this2.state.search,
              overlay: _this2.props.overlay
            });
          });
        }

        return React.createElement("div", {
          className: "search__products__blank"
        }, React.createElement("div", {
          className: "search__products__blank__img"
        }, React.createElement(ReactSVG, {
          path: searchEmptyImg
        })), React.createElement("div", {
          className: "search__products__blank__button"
        }, React.createElement(Button, {
          testingContext: "emptyCartHideOverlayButton",
          secondary: true,
          onClick: _this2.props.overlay.hide
        }, React.createElement(FormattedMessage, {
          id: "components.OverlayManager.Search.Search.3515754810",
          defaultMessage: "Continue Shopping"
        }))));
      })));
    }
  }, {
    key: "hasSearchPhrase",
    get: function get() {
      return this.state.search.length > 0;
    }
  }, {
    key: "redirectTo",
    get: function get() {
      return {
        pathname: searchUrl,
        search: "?".concat(this.searchQs)
      };
    }
  }, {
    key: "searchQs",
    get: function get() {
      return stringify({
        q: this.state.search
      });
    }
  }]);

  return Search;
}(React.Component); // Workaround ATM for:
// withRouter(Search): Function components do not support contextType


export default injectIntl(withRouter(function (props) {
  return React.createElement(Search, props);
}));